
import * as HT from 'ApplicationEntry/models/HippaTrustees';
import {createAction} from 'Shared/utilities/actionCreator';
import {reverseEnum} from 'Shared/utilities/enumUtility';

export enum HippaTrusteeActionType {
  ADD_TRUSTEE = 'HippaTrustee/ADD_TRUSTEE',
  CHANGE_FIRSTNAME = 'HippaTrustee/CHANGE_FIRSTNAME',
  CHANGE_LASTNAME = 'HippaTrustee/CHANGE_LASTNAME',
  DELETE_TRUSTEE = 'HippaTrustee/DELETE_TRUSTEE',
}

export const isHippaTrusteeAction = (action: any): action is HippaTrusteeAction =>
  action.type in reverseEnum(HippaTrusteeActionType);

export const addTrustee = () => createAction(HippaTrusteeActionType.ADD_TRUSTEE);
export const changeFirstName = (firstName: string, index : number) => createAction(HippaTrusteeActionType.CHANGE_FIRSTNAME,{firstName, index});
export const changeLastName = (lastName: string, index : number) => createAction(HippaTrusteeActionType.CHANGE_LASTNAME,{lastName, index});
export const deleteTrustee = (index : number) => createAction(HippaTrusteeActionType.DELETE_TRUSTEE, {index});


export type HippaTrusteeAction =
  | ReturnType<typeof addTrustee>
  | ReturnType<typeof changeFirstName>
  | ReturnType<typeof changeLastName>
  | ReturnType<typeof deleteTrustee>;

type HippaTrusteeState = HT.HippaTrustees;

export default (state: HippaTrusteeState, action: HippaTrusteeAction): HippaTrusteeState => {
  switch (action.type) {
    case HippaTrusteeActionType.ADD_TRUSTEE:      
     return HT.addTrustee()(state);
    case HippaTrusteeActionType.CHANGE_FIRSTNAME:
      return HT.changeFirstName(action.payload.firstName, action.payload.index)(state);
    case HippaTrusteeActionType.CHANGE_LASTNAME:
      return HT.changeLastName(action.payload.lastName, action.payload.index)(state);
    case HippaTrusteeActionType.DELETE_TRUSTEE:      
     return HT.deleteTrustee(action.payload.index)(state);
    default:
      return state;
  }
};